exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aparece[data-v-6c73a50d] {\n  height: auto;\n  opacity: 1;\n  transition: all 0.3s;\n  visibility: visible;\n}\n.oculta[data-v-6c73a50d] {\n  height: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s;\n}", ""]);

// exports
